"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_OPTIONS = exports.USE_INDICATOR_COLORS = exports.USE_COLORS = exports.USES = exports.ICON_SIZE_MAP = exports.ICON_COLOR_MAP = void 0;

var _colors = require("HubStyleTokens/colors");

var _Color = require("../core/Color");

var ICON_COLOR_MAP = {
  danger: _colors.ALERT_DANGER,
  primary: _colors.LORAX,
  secondary: _colors.LORAX,
  'secondary-ghost': _colors.OLAF,
  tertiary: _colors.HEFFALUMP,
  success: _colors.OZ,
  link: _colors.CALYPSO,
  'on-dark': _colors.OLAF
};
exports.ICON_COLOR_MAP = ICON_COLOR_MAP;
var ICON_SIZE_MAP = {
  'extra-small': 10,
  small: 16,
  medium: 24
};
exports.ICON_SIZE_MAP = ICON_SIZE_MAP;
var USES = ['danger', 'primary', 'primary-white', 'secondary', 'secondary-ghost', 'tertiary', 'success', 'tertiary-light', 'link', 'on-dark'];
exports.USES = USES;
var USE_COLORS = {
  danger: _colors.CANDY_APPLE_MEDIUM,
  primary: _colors.LORAX_MEDIUM,
  'primary-white': _colors.FLINT,
  secondary: _colors.LORAX_MEDIUM,
  tertiary: _colors.FLINT,
  'tertiary-light': _colors.FLINT,
  success: _colors.OZ_MEDIUM,
  link: _colors.CALYPSO_MEDIUM,
  ghost: 'transparent',
  'on-dark': (0, _Color.rgba)(_colors.OLAF, 0.5)
};
exports.USE_COLORS = USE_COLORS;
var USE_INDICATOR_COLORS = {
  danger: _colors.ALERT_DANGER,
  primary: _colors.LORAX,
  'primary-white': _colors.HEFFALUMP,
  secondary: _colors.LORAX,
  'secondary-ghost': _colors.OLAF,
  tertiary: _colors.HEFFALUMP,
  'tertiary-light': _colors.HEFFALUMP,
  success: _colors.OZ,
  link: _colors.CALYPSO,
  ghost: _colors.OLAF,
  'on-dark': _colors.OLAF
};
exports.USE_INDICATOR_COLORS = USE_INDICATOR_COLORS;
var SIZE_OPTIONS = {
  'extra-small': '20px',
  small: '28px',
  medium: '40px'
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;